module.exports = __webpack_public_path__ + "static/eyes_of_the_eagle-772d9c5f7c615951a9c51feb9d2ec24d.jpeg";